import { z } from 'zod'
import { SortingState } from '@tanstack/react-table'
import {
  CitiesRecord,
  CommandsAttachementsRecord,
  CommandsHistoryResponse,
  CommandsModificationHistoryResponse,
  CommandsResponse,
  CommandsStockResponse,
  PackagingRecord,
  StocksRecord,
  TrackingStatesRecord,
  UsersRecord,
} from '@/utils/types/pocketbase-types'

export const REVALIDATION_QUERY_KEY = ['commandes-list'] as const
// export type RECORD_TYPE = Required<
//   Pick<
//     CommandsRecord,
//     | 'id'
//     | 'code'
//     | 'product_name'
//     | 'quantity'
//     | 'delivery_man'
//     | 'client_source'
//     | 'client_name'
//     | 'client_phone'
//     | 'receiver_full_name'
//     | 'receiver_phone_number'
//     | 'receiver_address'
//     | 'city'
//     | 'price'
//     | 'extra_fees'
//     | 'packaging'
//     | 'status'
//     | 'reported_date'
//     | 'note'
//     | 'is_invoiced'
//     | 'is_ramassed'
//     | 'is_dlm_invoiced'
//     | 'trash'
//     | 'is_echange'
//     | 'package_opened'
//     | 'delivered_date'
//     | 'created'
//     | 'updated'
//     | 'receiver_full_name'
//     | 'receiver_address'
//   >
// > &
//   BaseSystemFields<Expand>
// type Expand = {
//   city?: { name: string }
//   delivery_man?: { full_name: string; phone: string }
//   status?: {
//     name: string
//     allowed_roles: string[]
//     bg_color: string
//     border_color: string
//     is_delivered: boolean
//     text_color: string
//   }
//   client_source?: {
//     full_name: string | null
//     store_name: string | null
//     phone: string | null
//     expand: {
//       city?: { name: string }
//     }

//     packaging?: { title: string; id: string }
//   }
// }

export type RECORD_TYPE = Required<CommandsResponse<Expand>>
type Expand = {
  city?: CitiesRecord
  delivery_man?: UsersRecord
  status?: TrackingStatesRecord
  client_source?: UsersRecord
  packaging?: PackagingRecord
  stock_products?: CommandsStockResponse<{ stock?: StocksRecord }>[]
  attachements?: CommandsAttachementsRecord[] | undefined
}
type CommandHistoryExpand = {
  action_user: UsersRecord
  status: TrackingStatesRecord
  attachements: CommandsAttachementsRecord[] | undefined
}
type CommandModificationHistoryExpand = {
  action_user: UsersRecord
}

const commandsStockSchema = z.object({
  quantity: z
    .number()
    .int() // must be an integer
    .positive() // must be > 0 (non-zero natural number)
    .describe('Quantity must be a non-zero natural number'),
  stock: z.string().min(1, 'Stock cannot be null or empty'), // ensures non-empty string
})
export type CommandHistoryRecordExpanded =
  CommandsHistoryResponse<CommandHistoryExpand>
export type CommandModificationHistoryRecordExpanded =
  CommandsModificationHistoryResponse<CommandModificationHistoryExpand>
export const formSchema = z.object({
  client_source: z.string().nullable(),
  receiver_full_name: z.string().optional(),
  receiver_phone_number: z.string().optional(),
  delivery_man: z.string().nullable(),
  city: z.string().min(1, { message: 'La ville est requise.' }),
  receiver_address: z.string().optional(),
  product_name: z.string().optional(),
  price: z.coerce
    .number()
    .nonnegative({ message: 'Le prix doit être un nombre positif.' }),
  extra_fees: z.coerce.number().nonnegative({
    message: 'Les frais supplémentaires doivent être un nombre positif.',
  }),
  packaging: z.string().nullable(),
  note: z.string().optional(),
  isEdit: z.boolean(),
  from_stock: z.boolean(),
  commands_stock: z.array(commandsStockSchema),
  is_echange: z.boolean().optional(),
  package_opened: z.boolean().optional(),
  attachments_to_delete: z.array(z.string()).optional(),
})

export type Form = z.infer<typeof formSchema>

export const allowedANDSearchColumns = [
  'trash',
  'status.reference_type',
  'is_ramassed',
  'stock_products.stock',
  'created',
  'updated',
  'reported_date',
  'status.name',
  'status.type',
  'is_invoiced',
  'is_echange',
  'status',
  'product_name',
  'status.reference_type',
  'client_source',
  'delivery_man',
  'city',
  'code-exact',
  'status_updated_at',
  'orGroup',
  'status.is_returned',
]
export const INPUT_DEFAULT_ACCESS_KEY = 'code'

export const intialSorting: SortingState = [
  { desc: true, id: 'status_table_order' },
]

export const initialFilters = [
  {
    id: 'trash',
    value: false,
  },
  {
    id: 'is_ramassed',
    value: true,
  },
]
